// External Packages
import { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Internal Packages
import { UtilityContext } from "../../context/util-context";

// External Components
import { MdAdd } from "react-icons/md";

// Internal Components
import SearchBar from "../UI/SearchBar";
import Heading from "../UI/Heading";
import LocationCard from "./LocationCard";
import PaginationMenu from "../UI/PaginationMenu";
import { requestAdminAPI } from "../../api/posh-api";
import LoadingCard from "../UI/LoadingCard";
import NoRecordsFound from "../UI/NoRecordsFound";
import AddLocation from "./AddLocation";
import ExportCsvButton from "../UI/ExportCsvButton";

/*
  * All Locations Page
  This page displays all Locations in the database.
*/

export default function Locations() {
  const { navigate } = useContext(UtilityContext);
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  // Default Filter
  const defaultFilters = {
    query: "",
  };

  // Filters in URL params
  const paramFilters = {};
  Object.keys(defaultFilters).forEach(
    (key) => (paramFilters[key] = params.get(key) ?? defaultFilters[key])
  );

  // Initialize States
  const [locations, setLocations] = useState([]);
  const [limit, setLimit] = useState(50);
  const [filter, setFilter] = useState(paramFilters);
  const [loading, setLoading] = useState(true);
  const [add, setAdd] = useState(false);

  /* ======================= FETCH RECORDS ======================= */
  const fetchRecords = async () => {
    try {
      setLoading(true);

      // Send Request
      const data = await requestAdminAPI("search", {
        table: "location",
        limit,
        filters: filter,
      });

      // Replace URL
      let url = "/locations?";
      Object.keys(filter).forEach((key) => {
        url += `${key}=${filter[key] ?? defaultFilters[key]}&`;
      });
      navigate(url, {}, { replace: true });

      setLocations(data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // Apply Filters
  useEffect(() => {
    fetchRecords();
  }, [filter, limit]);

  return (
    <div className="container grid">
      <AddLocation open={add} setOpen={setAdd} />
      <Heading title="Locations" isBackArrow={true}>
        <MdAdd
          onClick={() => setAdd(true)}
          className="text-3xl icon"
        />
        <ExportCsvButton array={locations} filename="locations" />
      </Heading>

      <SearchBar
        searchHandler={(query) => setFilter({ ...filter, query })}
        clearSearch={() => setFilter(defaultFilters)}
        searchValue={filter.query}
      />

      {loading ? (
        <LoadingCard columns={5} max={6} />
      ) : locations.length > 0 ? (
        <div className="list">
          {locations.map((location) => (
            <LocationCard location={location} key={location.id} />
          ))}
        </div>
      ) : (
        <NoRecordsFound />
      )}

      <PaginationMenu
        setLimit={setLimit}
        limit={limit}
        loading={loading}
        count={locations.length}
      />
    </div>
  );
}
